import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { AppConfigService, Log } from '@core/services/config/app-config.service';
import { InitAppService } from '@core/services/config/init-app.service';
import { CartCookieService } from '@core/services/storage/cart/cart-cookie.service';
import { UserStoreService } from '@core/services/storage/user/user-store.service';

@Injectable( {
    providedIn: 'root'
} )
export class CartConstraintsService {
    // services
    appConfig = inject(AppConfigService);
    initApp = inject(InitAppService);
    userStoreService = inject(UserStoreService);
    cartCookieService = inject(CartCookieService);

    // signals
    isMinPriceReached = signal<boolean>(false);
    isMinPriceReachedFC = signal<boolean>(false); // questo per il fast checkout, che dipende dalla nazione di spedizione, anche se il dominio non ha valuta GBP

    totaleCarrello = computed(() => {
        return this.cartCookieService.cartValue().articoli.reduce((total, item) => {
            let price: number = item.prezzo_privati_vat;

            if (this.userStoreService.isLoggedSignal()) {
                if (this.userStoreService.paga() == 'CON') {
                    if (this.userStoreService.isPrivateSignal()) price = item.prezzo_privati_vat;
                    if (this.userStoreService.isProSignal())     price = item.prezzo_pro_vat;
                }
                if (this.userStoreService.paga() == 'SENZA') {
                    if (this.userStoreService.isPrivateSignal()) price = item.prezzo_privati_novat;
                    if (this.userStoreService.isProSignal())     price = item.prezzo_pro_novat;
                }
            }

            return total + (price * item.item_quantita);
        }, 0);
    });

    constructor() {

        effect(() => {

            const totale = this.totaleCarrello(); // dipendenza reattiva
            const minPrice = this.appConfig.minCheckoutPriceGbp();

            let isMinPriceReached: boolean = false;
            let isMinPriceReachedFC: boolean = false;


            if (this.userStoreService.isPro()) {
                isMinPriceReached = true;
                isMinPriceReachedFC = true;
            }

            if (this.initApp.currencyCode !== 'GBP') {
                isMinPriceReached = true;
            }

            if(isMinPriceReached) {
                this.isMinPriceReached.set(true);
            }

            if(isMinPriceReachedFC) {
                this.isMinPriceReached.set(true);
            }

            if(!isMinPriceReached) {
                this.isMinPriceReached.set(totale >= minPrice);
            }

            if(!isMinPriceReachedFC) {
                this.isMinPriceReachedFC.set(totale >= minPrice);
            }
            
        });
    }

}